// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37vXg","inner":"Footer_inner__9Ej7X","nextIcon":"Footer_nextIcon__3A7tl","innerLeft":"Footer_innerLeft__2Fsqe"};